import {HStack, VStack} from 'platform/foundation';

import {SourcingVehicleListItemResponseBody} from '@dms/api/core';

import {suffixTestId, TestIdProps} from 'shared/web';

import {isAuctionVehicle} from '../../../utils/isAuctionVehicle';
import {isClassifiedsAdInactive} from '../../../utils/isClassifiedsAdInactive';
import {ActionButtonsVehicle} from '../../ActionButtonsVehicle/ActionButtonsVehicle';
import {convertVehicleTagsToVehicleHighlights} from '../../VehicleHighlights/utils/convertVehicleTagsToVehicleHighlights';
import {getInteriorMaterialHighlights} from '../../VehicleHighlights/utils/getInteriorMaterialHighlights';
import {VehicleHighlights} from '../../VehicleHighlights/VehicleHighlights';
import {VehiclePriceForm} from '../../VehiclePriceForm/VehiclePriceForm';

interface TableDetailRowProps extends TestIdProps {
  row: {index: number; original: SourcingVehicleListItemResponseBody};
  /** The row is selected (blue background), so the highlight flags get an outline. */
  isSelected?: boolean;
  setLastVisitedVehicle?: (adId: string, index: number) => void;
}

export function TableDetailRow({
  row: {
    index,
    original,
    original: {vehicleSummary, features},
  },
  setLastVisitedVehicle,
  isSelected,
  ...props
}: TableDetailRowProps) {
  const vehicleData = original.sourcingVehicle;
  const interiorMaterialHighlights = getInteriorMaterialHighlights(vehicleData?.interiorMaterial);
  const isDisabled =
    !isAuctionVehicle(original) && isClassifiedsAdInactive(original.sourcingVehicle);

  return (
    <VStack spacing={3}>
      <HStack justify="space-between">
        <VehicleHighlights
          isOutlined={isSelected}
          data={convertVehicleTagsToVehicleHighlights(
            [],
            [],
            Object.values(features).filter((i) => i.isHighlight),
            interiorMaterialHighlights
          )}
        />
        <ActionButtonsVehicle
          vehicle={original}
          onDetailOpen={() => setLastVisitedVehicle?.(vehicleData?.adId, index)}
          data-testid={suffixTestId('actionButtonsVehicle', props)}
        />
      </HStack>
      <VehiclePriceForm
        isDisabled={isDisabled}
        vehicleId={vehicleData?.adId}
        initialValues={{
          comment: vehicleSummary?.comment as string,
          purchasePrice: `${vehicleSummary?.purchasePrice}`,
          sellingPrice: `${vehicleSummary?.sellingPrice}`,
        }}
        data-testid={suffixTestId('vehiclePriceForm', props)}
      />
    </VStack>
  );
}
